import Input from '~/components/ui/Input/Input';
import EditorLabel from '../EditorLabel/EditorLabel';
import './EditorText.css';

interface EditorTextProps {
  name: string;
  value: string;
  onChange: (val: string) => void;
  label: string;
  maxlength?: number;
  onBlur?: () => void;
}

export default function EditorText({
  name,
  value,
  onChange,
  label,
  maxlength,
  onBlur
}: EditorTextProps) {
  return (
    <div className="EditorText">
      <div className="EditorText-header">
        <EditorLabel label={label} htmlFor={name} />
        <Input
          name={name}
          value={value}
          onChange={onChange}
          className="EditorText-input"
          maxlength={maxlength}
          onBlur={onBlur}
        />
      </div>
    </div>
  );
}
